export default __webpack_public_path__ + "static/media/img-jeffery-r.7e533a59.png";